module.exports = __webpack_public_path__ + "img/4a230d37764a4651863939b80389201e.svg";